import { NgModule } from '@angular/core';

import {
    InterviewRpcDataProviderService, interviewRpcDataProviderToken
} from './interview-rpc-data-provider.service';

import { InterviewMedicaidDataProviderService } from './interview-medicaid-data-provider.service';

import { InterviewSNAPDataProviderService } from './interview-snap-data-provider.service';

import { InterviewVeteranDataProviderService } from './interview-veteran-data-provider.service';

import {
    InterviewLISDataProviderService,
} from './interview-lis-data-provider.service';
import { InterviewCommunityDataProviderService } from './interview-community-data-provider.service';
import { InterviewSSIDataProviderService } from './interview-ssi-data-provider.service';
import { InterviewAddMemberDataProviderService, interviewAddmemberDataProviderToken } from './interview-addmember-data-provider.service';
import { InterviewMemberAssessmentDataProviderService } from './interview-member-assessment-data-provider.service';

import {
    interviewCommunityDataProviderToken,
    interviewLISDataProviderToken,
    interviewMedicaidDataProviderToken,
    interviewMemberAssessmentDataProviderToken,
    interviewSNAPDataProviderToken,
    interviewSSIDataProviderToken,
    interviewVeteranDataProviderToken
} from './interview-data-provider.tokens';




@NgModule({

    providers: [
        { provide: interviewRpcDataProviderToken, useClass: InterviewRpcDataProviderService },
        { provide: interviewCommunityDataProviderToken, useClass: InterviewCommunityDataProviderService },
        { provide: interviewLISDataProviderToken, useClass: InterviewLISDataProviderService },
        { provide: interviewMedicaidDataProviderToken, useClass: InterviewMedicaidDataProviderService },
        { provide: interviewSNAPDataProviderToken, useClass: InterviewSNAPDataProviderService },
        { provide: interviewVeteranDataProviderToken, useClass: InterviewVeteranDataProviderService },
        { provide: interviewSSIDataProviderToken, useClass: InterviewSSIDataProviderService },
        { provide: interviewAddmemberDataProviderToken, useClass: InterviewAddMemberDataProviderService },
        { provide: interviewMemberAssessmentDataProviderToken, useClass: InterviewMemberAssessmentDataProviderService },

    ]
})
export class InterviewProvidersModule {
}
